
import { UserModel, ContactViewModel, ContactModel } from "@/Domains";
import {
    Header, 
    FaBuilding, 
    FaCalendar, 
    FaDollarSign, 
    FaHashtag,  
    FaUser, 
    FaUserTag ,
    AppEnum,
    OptionHelper,
    TransactionEnums,
    RecordMap, 
} from "@/Shared";

import { TransactionViewModel } from "./ViewModels/TransactionViewModel";

export type SelectOption = {
    value: any,
    label: any
}

export class TransactionHeader {

    private constructor() { }

    getId() {
        return {
            key: 'id',
            icon: <FaHashtag />,
            label: 'ID',
            type: 'number',
            isSortable: true
        }
    }

    getTransactionDate() {
        return {
            key: 'transactionDate',
            icon: <FaCalendar />,
            label: 'Date',
            type: 'date',
            isSortable: true
        }
    }

    getOperationType(oprationTypes: AppEnum[]) {
        return {
            key: 'operationType',
            icon: <FaUserTag />,
            label: 'Opération',
            type: 'string',
            isSortable: true,
            filter: {
                label: "Opération",
                options: oprationTypes,
                case: 'sensitive'
            }
        }
    }

    getClient(contactMap: RecordMap<ContactModel>) {
        return {
            key: 'client',
            icon: <FaUserTag />,
            label: 'Client',
            type: 'string',
            isSortable: true,
            filter: {
                label: "Client",
                options: OptionHelper.contactOptions(contactMap.toArray()),
                case: 'sensitive'
            }
        }
    }

    getPropertyId() {
        return {
            key: 'propertyId',
            icon: <FaBuilding />,
            label: 'Bien',
            type: 'number',
            isSortable: true
        }
    }

    getOwner(contactMap: RecordMap<ContactModel>) {
        return {
            key: 'owner',
            icon: <FaUserTag />,
            label: 'Proprio',
            type: 'string',
            isSortable: true,
            filter: {
                label: "Propriétaire",
                options: OptionHelper.ownerOptions(contactMap.toArray()),
                case: 'sensitive'
            }
        }
    }

    getAdvisor(agents: RecordMap<UserModel>) {
        return {
            key: 'advisor',
            icon: <FaUser />,
            label: 'Conseillé',
            type: 'string',
            isSortable: true,
            isHidden: false,
            filter: {
                label: "Conseillé",
                case: 'sensitive',
                options:  OptionHelper.userOptions(agents.toArray())
            }
        }
    }


    getAgencyCom() {
        return {
            key: 'agencyCom',
            icon: <FaDollarSign />,
            label: 'Honor.',
            type: 'number',
            isSortable: true,
        }
    }

     getOperationPrice() {
        return {
            key: 'operationPrice',
            icon: <FaDollarSign />,
            label: 'Montant',
            type: 'number',
            isSortable: true,
        }
    }

    getClientCom() {
        return {
            key: 'clientCom',
            icon: <FaDollarSign />,
            label: 'H. Acquereur',
            type: 'number',
            isSortable: true,
        }
    }

    getOwnerCom() {
        return {
            key: 'ownerCom',
            icon: <FaDollarSign />,
            label: 'H. Properio',
            type: 'number',
            isSortable: true,
        }
    }

    static build(
        contactMap: RecordMap<ContactModel>,
        agentMap: RecordMap<UserModel>,
        viewEnums : TransactionEnums
    ): Record<keyof TransactionViewModel, Header<TransactionViewModel>> {

        const header = new TransactionHeader();

        return {
            id: header.getId(),
            transactionDate : header.getTransactionDate(),
            operationType: header.getOperationType(viewEnums.OperationTypeEnum),
            client: header.getClient(contactMap),
            propertyId : header.getPropertyId(),
            advisor : header.getAdvisor(agentMap),
            agencyCom : header.getAgencyCom(),
            operationPrice : header.getOperationPrice(),
            clientCom : header.getClientCom(),
            ownerCom : header.getOwnerCom(),
            owner : header.getOwner(contactMap)
        } as Record<keyof TransactionViewModel, Header<TransactionViewModel>>
    }
}